{
  "backButton": "Palaa kohtaan {prevMenuButton}",
  "moreActions": "Lisää toimintoja",
  "unavailable": "Ei saatavilla, laajenna saadaksesi lisätietoja"
}
